export default __webpack_public_path__ + "static/media/star.55fe0107.svg";